import * as React from 'react';

function DocumentIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={29.423}
      height={38.25}
      viewBox='0 0 29.423 38.25'
      {...props}
    >
      <path
        id='Icon_ionic-md-document'
        data-name='Icon ionic-md-document'
        d='M24.4,3.375H10.428A3.678,3.678,0,0,0,6.75,7.053V37.947a3.678,3.678,0,0,0,3.678,3.678H32.5a3.678,3.678,0,0,0,3.678-3.678v-22.8Zm-1.471,13.24V6.317l10.3,10.3Z'
        transform='translate(-6.75 -3.375)'
        fill='#9ccc65'
      />
    </svg>
  );
}
export default DocumentIcon;
